export default {"src":"/_next/static/media/ic_new_tooltip_circle.2b096b2c.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};